export default __webpack_public_path__ + "static/media/manjunath-metal-finishers.1f807de9.webp";